import { schema } from "normalizr";
import { ShippingAccount as ShippingAccountRecord } from "records/shipping-accounts";

export const ShippingAccount = new schema.Entity(
    "shippingAccount",
    {},
    {
        idAttribute: "id",
    }
);

(ShippingAccount as any).record = ShippingAccountRecord;
